import {
  AfterViewInit,
  Component, ElementRef, Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { ProductService } from "../../../shared/services/product.service";
import { Product } from "../../../shared/classes/product";
import { IUsaProduct } from "src/app/shared/Models/TopCollectionProduct";
import {
  IExtendPagination,
  PaginatedResult,
} from "src/app/shared/Pagination/IPagination";
import { Observable, Subject } from "rxjs";
import { HomeService } from "src/app/shared/services/home.service";
import { PageEvent } from "@angular/material/paginator";
import {
  ICategoryCollection,
  ISubBrandCollection,
  ISubCategoryCollection,
} from "src/app/shared/Models/ICategories";
import { FormControl } from "@angular/forms";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  retry,
  startWith,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { Location, PopStateEvent } from "@angular/common";
import { CategoryService } from "src/app/shared/services/Category.service";
import { IUser } from "src/app/shared/Models/IUser";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { IMenu, NavService } from "src/app/shared/services/nav.service";

@Component({
  selector: "app-usa-collection",
  templateUrl: "./usa-collection.component.html",
  styleUrls: ["./usa-collection.component.scss"],
})
export class USACollectionComponent implements OnInit, OnDestroy, AfterViewInit {




  brandCollectionList$: Observable<PaginatedResult<IUsaProduct[]>>;
  public products: Product[] = [];
  public brandCollectionList: IUsaProduct[] = [];

  _categoryQuery$: Observable<string>;
  _subCategoryQuery$: Observable<string>;
  _brandQuery$: Observable<string>;

  public subBrandCollection: ISubBrandCollection[];

  public categoryCollection$: Observable<ICategoryCollection[]>;
  public categoryCollection: ICategoryCollection[] = [];

  public subCategoryCollection$: Observable<ISubCategoryCollection[]>;
  public subCategoryCollection: ISubCategoryCollection[] = [];

  searchInputControl: FormControl = new FormControl();
  _unsubscribeAll: Subject<any> = new Subject<any>();

  public grid: string = "col-xl-4 col-md-6";
  public layoutView: string = "grid-view";
  public brands: any[] = [];

  public minPrice: number = 0;
  public maxPrice: number = 2000;

  public sortBy: string; // Sorting Order
  public filterBy: string; // Sorting Order
  public mobileSidebar: boolean = false;
  public loader: boolean = true;

  @Input() pagination: IExtendPagination;
  searchTerm = "";
  resetCategoryWithSubs = false;
  globalSearch = "";

  @Input() categoryName: string;
  @Input() subCategryName: string;
  @Input() brandName: string;
  @Input() minPriceValue: number;
  @Input() maxPriceValue: number;
  @Input() currentPage: number;
  @Input() pageSize: number;
  @Input() orderBy: string;
  @Input() currentPageValue: number;
  @Input() pageSizeValue: number;
  buyerId = "";
  isUrlOpenByLink = false;
  totalCount = 0;
  wholesalerAccount = 0;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _spinner: NgxSpinnerService,
    private _homeService: HomeService,
    private viewScroller: ViewportScroller,
    private _categoryService: CategoryService,
    private _navService: NavService,
    public productService: ProductService
  ) {

    this._categoryQuery$ = this._categoryService.getCategoryQuery$;
    this._categoryQuery$.subscribe((category) => {
      this.categoryName = category;
    });

    this._subCategoryQuery$ = this._categoryService.getSubCategoryQuery$;
    this._subCategoryQuery$.subscribe((sub) => {
      this.subCategryName = sub;
    });

    this._brandQuery$ = this._categoryService.getBrandQuery$;
    this._brandQuery$.subscribe((brand) => {
      this.brandName = brand;
    });

    var user: IUser = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.buyerId = user.id;
    }

    if (this.isUrlOpenByLink) {
      return;
    }

    this._activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.category) {
        this.categoryName = params.category;

        this._homeService.getSubCategoryCollection$.subscribe((data) => {
          if (!data) {
            this._homeService
              .loadSubCategoriesByCategoryName(this.categoryName)
              .subscribe();
          }
        });
      }


      if (params.subCategory) {
        this.subCategryName = params.subCategory;

        this._homeService.getSubBrandCollection$.subscribe((data) => {
          if (!data) {
            this._homeService
              .loadsubBrandBySubCategoryName(this.subCategryName)
              .subscribe();
          }
        });
      }

      if (params.brand || this.brandName) {
        this.brandName = params.brand ? params.brand : this.brandName;
      } else {
        this.brandName = "";
      }

      if (params.orderBy) {
        this.orderBy = params.orderBy;
      } else {
        this.orderBy = "";
      }

      if (params.filtered) {
        this.filterBy = params.filtered;
      } else {
        this.filterBy = "";
      }

      if (params.searchTerm) {
        this.searchTerm = params.searchTerm;
      } else {
        this.searchTerm = "";
      }

      if (params.wholesalerAccount) {
        this.wholesalerAccount = 1
      } else {
        this.wholesalerAccount = 0

      }

      this.currentPageValue = 1;
      this.pageSizeValue = 48;
      this.pagination = {
        currentPage: this.currentPageValue,
        pageSize: this.pageSizeValue,
        category: this.categoryName ? this.categoryName : undefined,
        subCategory: this.subCategryName ? this.subCategryName : undefined,
        brand: this.brandName ? this.brandName : undefined,
        minPrice: this.minPriceValue,
        maxPrice: this.maxPriceValue,
        orderBy: this.orderBy ? this.orderBy : undefined,
        filtered: this.filterBy ? this.filterBy : undefined,
        buyerId: this.buyerId ? this.buyerId : "",
        searchTerm: this.searchTerm ? this.searchTerm : "",
        wholesalerAccount: this.wholesalerAccount
      };

      this.updateProductFilter();

      this.isUrlOpenByLink = true;
    });
  }
  ngAfterViewInit(): void {

    if (this.wholesalerAccount == 1) {
      var getWholesaleId = document.getElementById('wholesaleId');
      getWholesaleId.setAttribute("checked", "");
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  ngOnInit(): void {
    this.brandCollectionList$ = this._homeService.getBrandCollectionList$;
    this.brandCollectionList$.subscribe((data) => {
      if (!data) {
        return;
      }
      this.totalCount = data.pagination.totalCount;
      this.pagination = data.pagination;
      this.brandCollectionList = data.result;
    });

    // Subscribe to search input field value changes
    this.searchInputControl.valueChanges
      .pipe(
        takeUntil(this._unsubscribeAll),
        map((value) => {
          this.searchTerm = value ? value : "";
          this.currentPageValue = 1;
          this.pageSizeValue = 48;

          this.pagination = {
            currentPage: this.currentPageValue,
            pageSize: this.pageSizeValue,
            category: undefined,
            subCategory: undefined,
            brand: undefined,
            minPrice: this.minPriceValue,
            maxPrice: this.maxPriceValue,
            orderBy: this.orderBy,
            searchTerm: this.searchTerm,
            buyerId: this.buyerId ? this.buyerId : "",
            filtered: this.filterBy ? this.filterBy : undefined,
          };

          return this.pagination;
        }),
        debounceTime(750),
        distinctUntilChanged(),
        tap(() => { }),
        switchMap((reqestParamters: IExtendPagination) => {


          let params = {
            category: null,
            subCategory: null,
            brand: null,
            orderBy: null,
            filtered: null,
            searchTerm: reqestParamters.searchTerm.trim() ? reqestParamters.searchTerm.trim() : ''
          }



          this._router.navigate([], {
            relativeTo: this._activatedRoute,
            queryParams: params,
            queryParamsHandling: 'merge', // preserve the existing query params in the route
            skipLocationChange: false  // do trigger navigation
          }).finally(() => {
            this.viewScroller.setOffset([120, 120]);
            this.viewScroller.scrollToAnchor('products'); // Anchore Link
          });

          this._categoryService._categoryQuery$.next(null);
          this._categoryService._subCategoryQuery$.next(null);
          this._categoryService._brandQuery$.next(null);


          if (reqestParamters.searchTerm) {
            return this._router.navigateByUrl(
              `/shop/product?searchTerm=${reqestParamters.searchTerm}`
            );
          } else {
            return this._router.navigateByUrl(`/shop/product`);
          }

          return this._homeService
            .searchBrands(reqestParamters)
            .pipe(retry(3), startWith([]));
        })
      )
      .subscribe({
        next: () => {
          this.categoryName = undefined;
          this.subCategryName = undefined;
          this.brandName = undefined;
        },
        error: () => { },
      });


  }

  // SortBy Filter
  sortedBy(value) {
    this.orderBy = value;

    this.updateProductFilter();
  }

  // SortBy Filter
  filteredBy(value) {
    this.filterBy = value;

    this.updateProductFilter();
  }

  // Change Grid Layout
  updateGridLayout(value: string) {
    this.grid = value;
  }

  // Change Layout View
  updateLayoutView(value: string) {
    this.layoutView = value;
    if (value == "list-view") this.grid = "col-lg-12";
    else this.grid = "col-xl-3 col-md-6";
  }

  // Mobile sidebar
  toggleMobileSidebar() {
    this.mobileSidebar = !this.mobileSidebar;
  }

  // updateBrandFilter(event) {
  //   this.pagination = event;
  //   this._homeService.searchBrands("noValue", this.pagination).subscribe();
  // }


  updateCategory(category) {

    this.categoryName = category;
    this.subCategryName = undefined;
    this.brandName = undefined;
    this.searchTerm = null;

    if (this.searchInputControl.value) {
      this.searchInputControl.setValue(null);
      this.searchTerm = "";
    }

    this.updateProductFilter();
  }

  updateSubCategryName(event) {

    this.subCategryName = event;
    this.brandName = undefined;
    this.searchTerm = "";
    if (this.searchInputControl.value) {
      this.searchInputControl.setValue(null);
      this.searchTerm = "";
    }

    this.updateProductFilter();
  }

  upadteBrandName(event) {
    this.brandName = event;
    if (this.searchInputControl.value) {
      this.searchInputControl.setValue(null);
      this.searchTerm = "";
    }

    this.updateProductFilter();
  }

  upadteMinAndMaxPrice(event) {
    if (this.resetCategoryWithSubs) {
    }
    this.minPrice = event.minPrice;
    this.maxPrice = event.maxPrice;
    this.minPriceValue = event.minPrice;
    this.maxPriceValue = event.maxPrice;

    this.updateProductFilter();
  }

  updatePaginationValue(event) {
    this.currentPageValue = event.currentPage ? event.currentPage : 1;
    this.pageSizeValue = event.pageSize ? event.pageSize : 48;

    this.updateProductFilter();
  }

  updateProductFilterCategorySpan() {
    this.globalSearch = "";
    this.subCategryName = undefined;
    this.brandName = undefined;
    this.updateProductFilter();
  }

  updateProductFilterSubCategorySpan() {
    this.globalSearch = "";

    this.brandName = undefined;
    this.updateProductFilter();
  }

  switchPage(event: PageEvent, searchQuery: string = "") {
    this.pagination = {
      currentPage: 1,
      pageSize: 48,
      category: this.categoryName,
      subCategory: this.subCategryName,
      brand: this.brandName,
      maxPrice: this.maxPriceValue,
      minPrice: this.minPrice,
      buyerId: this.buyerId ? this.buyerId : "",
      orderBy: this.orderBy ? this.orderBy : undefined,
      filtered: this.filterBy ? this.filterBy : undefined,
      searchTerm: this.searchTerm ? this.searchTerm : "",
    };

    this._homeService.brandsList(this.pagination).subscribe();
  }

  resetFilter() {
    this.minPrice = 0;
    this.maxPrice = 2000;
    this.categoryName = undefined;
    this.subCategryName = undefined;
    this.brandName = undefined;
    this.minPriceValue = this.minPrice;
    this.maxPriceValue = this.maxPrice;
    this.filterBy = undefined;
    this.searchTerm = undefined;
    this.orderBy = undefined;
    this.wholesalerAccount = 0;

    if (this.searchInputControl.value) {
      this.searchInputControl.setValue(null);
      this.searchTerm = "";
    }
    this._categoryService._subCategoryQuery$.next(null);
    this._categoryService._brandQuery$.next(null);


    this.updateProductFilter();
  }

  resetCategoryService() {
    this._categoryService._categoryQuery$.next(null);
    this._categoryService._subCategoryQuery$.next(null);
    this._categoryService._brandQuery$.next(null);
  }


  onChangeEventFunc(event) {
    console.log(event);
    const isChecked = event.target.checked;

    this.wholesalerAccount = isChecked ? 1 : 9;
    this.updateProductFilter();
  }

  isAuthorized() {
    var buyer: IUser = JSON.parse(localStorage.getItem("user"));
    if (!buyer) {
      return;
    }
    var isWholeSaleAccount = buyer.isWholeSaleAccount;
    var result = isWholeSaleAccount.toString();

    var isTrue = result == "True";
    return isTrue;
  }

  updateProductFilter() {
    this.globalSearch = "";

    this.pagination = {
      currentPage: this.currentPageValue,
      pageSize: this.pageSizeValue,
      category: this.categoryName,
      subCategory: this.subCategryName,
      brand: this.brandName,
      minPrice: this.minPriceValue,
      maxPrice: this.maxPriceValue,
      orderBy: this.orderBy,
      searchTerm: this.searchTerm,
      filtered: this.filterBy,
      buyerId: this.buyerId ? this.buyerId : "",
      wholesalerAccount: this.wholesalerAccount,
    };

    let parameters = {
      category: this.categoryName ? this.categoryName : null,
      subCategory: this.subCategryName ? this.subCategryName : null,
      brand: this.brandName ? this.brandName : null,
      orderBy: undefined,
      filtered: this.filterBy ? this.filterBy : undefined,
      searchTerm: this.searchTerm ? this.searchTerm : undefined,
      wholesalerAccount: this.wholesalerAccount == 1 ? this.wholesalerAccount : undefined
    };

    this._router
      .navigate([], {
        relativeTo: this._activatedRoute,
        queryParams: parameters,
        queryParamsHandling: "merge", // remove to replace all query params by provided
      })
      .finally(() => {
        this.viewScroller.setOffset([120, 120]);
        this.viewScroller.scrollToAnchor("products"); // Anchore Link
      });

    this._homeService.searchBrands(this.pagination).subscribe({
      next: () => {
        document.body.scrollTop = 0;
      },
      error: () => { },
    });
  }

  categoryTitle(title: string): string {
    var getTitle = title;
    var code = localStorage.getItem("code");
    if (!code) {

      return getTitle;
    }

    this._navService.getMenus$.subscribe((menus: IMenu[]) => {
      if (menus) {
        var code = localStorage.getItem("code");

        if (code) {
          menus.forEach((nav) => {

            if (nav.mainTitle == getTitle) {
              getTitle = nav.titleInKurdish ? nav.titleInKurdish : nav.mainTitle;
              return getTitle;
            }


          });
        }
      } else {
        this._navService.loadMenus().subscribe();
      }
    });

    return getTitle;
  }



  subCategoryTitle(title: string): string {

    var getTitle = title;
    var code = localStorage.getItem("code");
    if (!code) {
      return getTitle;
    }

    this._navService.getMenus$.subscribe((menus: IMenu[]) => {
      if (menus) {
        var code = localStorage.getItem("code");

        if (code) {
          menus.forEach((nav) => {

            if (nav.children) {

              nav.children.forEach(subNav => {



                if (subNav.mainTitle == getTitle) {
                  getTitle = subNav.titleInKurdish ? subNav.titleInKurdish : subNav.mainTitle;
                  return getTitle;
                }



              })


            }

          });
        }
      } else {
        this._navService.loadMenus().subscribe();
      }
    });

    return getTitle;

  }



  brandCategoryTitle(title: string): string {

    var getTitle = title;
    var code = localStorage.getItem("code");
    if (!code) {
      return getTitle;
    }

    this._navService.getMenus$.subscribe((menus: IMenu[]) => {
      if (menus) {
        var code = localStorage.getItem("code");

        if (code) {
          menus.forEach((nav) => {

            if (nav.children) {

              nav.children.forEach(subNav => {


                if (subNav.children) {


                  subNav.children.forEach(brandNav => {


                    if (brandNav.mainTitle == getTitle) {
                      getTitle = brandNav.titleInKurdish ? brandNav.titleInKurdish : brandNav.mainTitle;
                      return getTitle;
                    }

                  })




                }





              })


            }

          });
        }
      } else {
        this._navService.loadMenus().subscribe();
      }
    });

    return getTitle;

  }

  wholesaleAuthrization(): boolean {
    var user: IUser = JSON.parse(localStorage.getItem('user'));
    if (user && user.isWholeSaleAccount.toString() == "True") {

      return true;

    }
    else {
      return false;
    }
  }


}
